import { useTranslation } from 'react-i18next';

export default function GuidesSection() {
  const { t, i18n } = useTranslation();
  const prefix = i18n.language === 'pt' ? '' : '/' + i18n.language;

  const guides = [
    {
      title: t('guides.spreadsheetGuide'),
      desc: t('guides.spreadsheetGuideDesc'),
      icon: 'ri-file-list-3-line',
      href: prefix + '/cssbuy-spreadsheet',
      color: 'bg-primary-50 text-primary-600',
    },
    {
      title: t('guides.reviewGuide'),
      desc: t('guides.reviewGuideDesc'),
      icon: 'ri-star-line',
      href: prefix + '/cssbuy-spreadsheet',
      color: 'bg-accent-50 text-accent-600',
    },
    {
      title: t('guides.shippingGuide'),
      desc: t('guides.shippingGuideDesc'),
      icon: 'ri-truck-line',
      href: prefix + '/cssbuy-spreadsheet',
      color: 'bg-secondary-50 text-secondary-600',
    },
    {
      title: t('guides.qcGuide'),
      desc: t('guides.qcGuideDesc'),
      icon: 'ri-camera-line',
      href: prefix + '/cssbuy-spreadsheet',
      color: 'bg-primary-50 text-primary-600',
    },
  ];

  return (
    <section className="section-padding bg-background-50">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="font-heading text-2xl md:text-3xl lg:text-4xl font-bold text-foreground-950 mb-4">
            {t('guides.title')}
          </h2>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-6">
          {guides.map((guide, index) => (
            <a
              key={index}
              href={guide.href}
              className="group card p-5 md:p-6 hover:shadow-md transition-all duration-200"
            >
              <div className={`w-12 h-12 flex items-center justify-center rounded-lg ${guide.color} mb-4`}>
                <i className={`${guide.icon} text-xl`}></i>
              </div>
              <h3 className="font-heading text-base md:text-lg font-semibold text-foreground-900 mb-2 group-hover:text-primary-600 transition-colors">
                {guide.title}
              </h3>
              <p className="text-sm text-foreground-600 leading-relaxed mb-4">
                {guide.desc}
              </p>
              <span className="inline-flex items-center text-sm font-medium text-primary-600 group-hover:text-primary-700 transition-colors">
                {t('guides.readMore')}
                <i className="ri-arrow-right-line ml-1.5 group-hover:translate-x-1 transition-transform"></i>
              </span>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}